import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const authService = createApi({
  tagTypes: ["wishlist"],
    reducerPath: "auth",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
    prepareHeaders: (headers, { getState }) => {
      const token = getState()?.authReducer?.userToken;

      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }

      headers.set("accept", "application/json");

      return headers;
    },
  }),
  endpoints: (builder) => ({
    authLogin: builder.mutation({
      query: (loginData) => ({
        url: "admin/login",
        method: "POST",
        body: loginData,
      }),
    }),

    requestOtp: builder.mutation({
      query: (data) => ({
        url: "auth/request-otp",
        method: "POST",
        body: data,
      }),
    }),

    verifyOtp: builder.mutation({
      query: (data) => ({
        url: "auth/verify-otp",
        method: "POST",
        body: data,
      }),
    }),

    loginWithPassword: builder.mutation({
      query: (data) => ({
        url: "auth/login-password",
        method: "POST",
        body: data,
      }),
    }),


    getWishlist: builder.query({
      query: () => ({
        url: "user/wishlist",
        method: "GET",
      }),
      providesTags: ["wishlist"],
    }),

    addWishlist: builder.mutation({
      query: (productId) => ({
        url: `user/wishlist/${productId}`,
        method: "POST",
      }),
      invalidatesTags: ["wishlist"],
    }),

    removeWishlist: builder.mutation({
      query: (productId) => ({
        url: `user/wishlist/${productId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["wishlist"],
    }),

    syncWishlist: builder.mutation({
      query: (product_ids) => ({
        url: "user/wishlist/sync",
        method: "POST",
        body: { product_ids },
      }),
      invalidatesTags: ["wishlist"],
    }),

    userMe: builder.query({
      query: () => ({
        url: "user/me",
        method: "GET",
      }),
    }),

    userPurchasedProducts: builder.query({
      query: () => ({
        url: "user/purchased-products",
        method: "GET",
      }),
    }),


    updateProfile: builder.mutation({
      query: (data) => ({
        url: "user/profile",
        method: "PUT",
        body: data,
      }),
    }),

    requestMobileChangeOtp: builder.mutation({
      query: (data) => ({
        url: "user/mobile-change/request",
        method: "POST",
        body: data,
      }),
    }),

    verifyMobileChangeOtp: builder.mutation({
      query: (data) => ({
        url: "user/mobile-change/verify",
        method: "POST",
        body: data,
      }),
    }),

    setPassword: builder.mutation({
      query: (data) => ({
        url: "user/set-password",
        method: "POST",
        body: data,
      }),
    }),

    changePassword: builder.mutation({
      query: (data) => ({
        url: "user/change-password",
        method: "POST",
        body: data,
      }),
    }),

    userLogout: builder.mutation({
      query: () => ({
        url: "user/logout",
        method: "POST",
      }),
    }),
  }),
});

export const {
  useAuthLoginMutation,
  useRequestOtpMutation,
  useVerifyOtpMutation,
  useLoginWithPasswordMutation,
  useUserMeQuery,
  useUserPurchasedProductsQuery,
  useUpdateProfileMutation,
  useRequestMobileChangeOtpMutation,
  useVerifyMobileChangeOtpMutation,
  useSetPasswordMutation,
  useChangePasswordMutation,
  useUserLogoutMutation,
  useGetWishlistQuery,
  useAddWishlistMutation,
  useRemoveWishlistMutation,
  useSyncWishlistMutation
} = authService;

export default authService;
